import React, { useEffect, useState } from 'react';
import { FaPen } from 'react-icons/fa';
import { getAdminProfileByEmail, updateEmployee } from '../../../services/admin/api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './view-profile.css';

const ViewProfile = () => {
  const [profile, setProfile] = useState(null);
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(true);

  const [isEditing, setIsEditing] = useState(false);

  const fetchProfile = () => {
    setLoading(true);

    const email = localStorage.getItem('user_email');

    if (email) {
      getAdminProfileByEmail(email)
        .then((data) => {
          setProfile(data);
          setPhone(data.phonenumber || '');
        })
        .catch(() => {
          toast.error('Failed to load profile.');
        })
        .finally(() => setLoading(false));
    } else {
      toast.error('User email not found in local storage.');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!phone || phone.length !== 10) {
      toast.error('Please enter a valid 10-digit mobile number.');
      return;
    }

    try {
      if (!profile || !profile.userid) {
        toast.error('Profile ID is missing. Cannot update.');
        return;
      }

      const payload = {
        ...profile,
        phonenumber: phone,
      };

      await updateEmployee(profile.userid, payload);

      toast.success('Profile Updated Successfully', {
        autoClose: 3000,
      });

      setProfile((prev) => ({
        ...prev,
        phonenumber: phone,
      }));

      setIsEditing(false);

    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        err?.message ||
        'Something went wrong while updating.';

      if (
        errorMessage.includes('No values were changed') ||
        errorMessage.includes('IllegalArgumentException')
      ) {
        toast.error(
          'No changes detected. Please modify the number before updating.'
        );
      } else {
        toast.error(errorMessage);
      }
    }
  };

  const handleCancel = () => {
    setPhone(profile.phonenumber || '');
    setIsEditing(false);
    toast.info('Changes discarded.');
  };

  if (loading)
    return (
      <div className="centered-message">
        <div className="spinner"></div>
        <div>Loading Profile Details ...</div>
      </div>
    );

  if (!profile)
    return (
      <div className="admin-profile-status-message">
        No profile found.
      </div>
    );

  return (
    <div className="admin-add-employee-container">
      <div className="admin-add-employee-form-card">

        <form
          onSubmit={handleSubmit}
          className="admin-add-employee-form"
        >

          <div className="admin-form-row">
            <div className="admin-form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                value={profile.username || ''}
                readOnly
                disabled
              />
            </div>

            <div className="admin-form-group">
              <label htmlFor="companyName">Company Name</label>
              <input
                type="text"
                id="companyName"
                value={profile.companyname || ''}
                readOnly
                disabled
              />
            </div>
          </div>

          <div className="admin-form-row">

            <div className="admin-form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={profile.email || ''}
                readOnly
                disabled
              />
            </div>

            <div className="admin-form-group">
              <label htmlFor="contactNumber">
                Contact Number
              </label>

              <div className="phone-input-wrapper">

                <input
                  type="text"
                  id="contactNumber"
                  value={phone}
                  onChange={(e) =>
                    setPhone(
                      e.target.value.replace(/\D/g, '')
                    )
                  }
                  maxLength={10}
                  pattern="\d*"
                  placeholder="Enter 10-digit mobile number"
                  readOnly={!isEditing}
                  className={!isEditing ? 'readonly-input' : ''}
                />

                {!isEditing && (
                  <FaPen
                    className="edit-icon"
                    onClick={() => setIsEditing(true)}
                  />
                )}
              </div>
            </div>
          </div>

          {isEditing && (
            <div className="admin-form-actions">

              <button
                type="submit"
                className="admin-submit-button"
              >
                Update
              </button>

              <button
                type="button"
                className="admin-cancel-button"
                onClick={handleCancel}
              >
                Cancel
              </button>

            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default ViewProfile;